<template>
<div class="spackageContentMgt">
    <div class="content">
        <img preview :src="item.coverPicture.furl" alt="">
        <div class="detailed">
            <div class="title btn-operate-list">
                <div class="blod">{{item.subject}}</div>
                <div>
                    <div class="tr">
                        <!-- 上架 -->
                        <div v-if="item.status === 30">
                            <el-button @click="soldOut(param)" v-if="permission.btnList.indexOf('A020504')==-1" type="text" size="small">下架</el-button>
                            <i class="separator" v-if="permission.btnList.indexOf('A020504')==-1">|</i>
                            <Share v-if="permission.btnList.indexOf('A020505')==-1" :row="item"></Share>
                            <el-button @click="handleEdit(param)" v-if="permission.btnList.indexOf('A020502')==-1" type="text" size="small">编辑</el-button>
                            <i class="separator" v-if="permission.btnList.indexOf('A020502')==-1">|</i>
                            <el-dropdown>
                                <span class="el-dropdown-link">
                                    <el-button type="text" size="small">更多</el-button>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="stopToUpdate(param)" v-if="item.isupdate === 1">停止更新</el-dropdown-item>
                                    <el-dropdown-item @click.native="beginToUpdate(param)" v-if="item.isupdate === 0">开始更新</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDel(param)" v-if="permission.btnList.indexOf('A020509')==-1">删除</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleRecommend(param)" v-if="permission.btnList.indexOf('A020507')==-1 && item.isinnerrecomm === 0">加入推荐</el-dropdown-item>
                                    <el-dropdown-item @click.native="cancelRecommend(param)" v-if="permission.btnList.indexOf('A020507')==-1 && item.isinnerrecomm === 1">取消推荐</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <!-- 下架 -->
                        <div v-if="item.status === 31">
                            <el-button v-if="permission.btnList.indexOf('A020503')==-1" @click="putAway(param)" type="text" size="small">上架</el-button>
                            <i class="separator" v-if="permission.btnList.indexOf('A020503')==-1">|</i>
                            <Share :row="item" v-if="permission.btnList.indexOf('A020505')==-1"></Share>
                            <el-button @click="handleEdit(param)" v-if="permission.btnList.indexOf('A020502')==-1" type="text" size="small">编辑</el-button>
                            <i class="separator" v-if="permission.btnList.indexOf('A020502')==-1">|</i>
                            <el-button @click="handleDel(param)" type="text" size="small" v-if="permission.btnList.indexOf('A020509')==-1">删除</el-button>
                        </div>
                        <!-- 待上架 -->
                        <div v-if="item.status === 10">
                            <el-button @click="handleEdit(param)" v-if="permission.btnList.indexOf('A020502')==-1" type="text" size="small">编辑</el-button>
                            <i class="separator" v-if="permission.btnList.indexOf('A020502')==-1">|</i>
                            <el-button @click="handleDel(param)" type="text" size="small" v-if="permission.btnList.indexOf('A020509')==-1">删除</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="info">
                <span class="text">
                    {{item.description}}
                </span>
            </div>
            <div class="statusBox">
                <div class="status" v-if="item.isupdate === 1">更新至{{item.counts}}集（更新中）</div>
                <div class="status" v-if="item.isupdate === 0">更新至{{item.counts}}集（已完结）</div>
            </div>
            <div class="price error">
                <span v-if="item.feetype === 1">
                    {{item.feetypeName}}
                </span>
                <span v-if="item.feetype === 2">
                    ￥{{item.saleprice}}
                </span>
            </div>
        </div>
    </div>
    <div class="filters">
        <div class="add">
            <el-button @click.native="shopAdd" type="primary">添加商品</el-button>
        </div>
        <div class="search">
            <el-input v-model="param.subject" placeholder="请输入文件名称" class="condition"></el-input>
            <el-button type="primary" @click="search" plain>搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="sortNum" label="序号" width="100">
                <template slot-scope="scope">
                    <div class="sort">
                        {{scope.row.sortNum + (($refs.page.page.page-1) * 10)}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="subject" label="单品名称" width="456" class-name="productBox">
                <template slot-scope="scope">
                    <div class="product">
                        <div class="imgBox">
                            <img :src="scope.row.coverurl" alt="">
                        </div>
                        <div class="textBox">
                            <div class="title">
                                <span class="text">{{scope.row.subject}}</span>
                            </div>
                            <div class="feetype">
                                <span v-if="scope.row.feetype === 2">￥{{scope.row.saleprice}}</span>
                                <span v-if="scope.row.feetype === 1">免费</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="kmctype" label="类型" class-name="source" width="80">
                <template slot-scope="scope">
                    <div class="vsource">
                        {{scope.row.kmctypetext}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="datetime" label="发布时间" class-name="source" width="160"></el-table-column>
            <el-table-column prop="status" label="上架状态" class-name="source">
                <template slot-scope="scope">
                    <div :class="{'status10': scope.row.status === 10, 'status30': scope.row.status === 30, 'status31': scope.row.status === 31}">
                        {{scope.row.statustext}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column  label="操作" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <el-button type="text" size="small" @click="sortShow(scope.row)">排序</el-button>
                        <i class="separator">|</i>
                        <el-button type="text" size="small" @click="handleCatalogEdit(scope.row)">编辑</el-button>
                        <i class="separator">|</i>
                        <Share :row="scope.row" :line="true"></Share>
                    </div>
                    <transition name="slide-sort">
                        <div class="sort-edit" v-show="scope.row.innerid === sortShowId">
                            <span>排列到第</span>
                            <el-input v-model="sortNum"></el-input>
                            <span>位</span>
                            <el-button type="primary" @click="confirmSort(scope.row)" size="mini">确定</el-button>
                            <el-button size="mini" @click="sortShowId = null">取消</el-button>
                        </div>
                    </transition>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <page :total="total" @getList="_getList" ref="page"></page>
    <!-- <spackageCatalogEdit ref="spackageCatalogEdit" @list="_getList" :pageData="page" :innerid="$route.query.innerid"></spackageCatalogEdit>
    <SpackageVideoEidt ref="spackageVideoEidt"></SpackageVideoEidt>
    <spackageContentEdit ref="spackageContentEdit"></spackageContentEdit>
    <spackageLocalhostVideoEdit ref="spackageLocalhostVideoEdit"></spackageLocalhostVideoEdit>
    <scrollBox ref="videoScrollBox" :uploadType="uploadVideoType" @saveMaterialFile="setMaterialVideofile"></scrollBox> -->
    <AddShop :spackageInnerid="param.assetinnerid" ref="addShop" @setShop="setShop"></AddShop>
</div>
</template>

<script>
import Page from 'base/page/page'
import SpackageCatalogEdit from 'views/cms/spackage/SpackageCatalogEdit'
import SpackageVideoEidt from 'views/cms/spackage/SpackageVideoEdit'
import SpackageContentEdit from 'views/cms/spackage/SpackageContentEdit'
import SpackageLocalhostVideoEdit from 'views/cms/spackage/SpackageLocalhostVideoEdit'
import AddShop from './AddShop'
import Share from 'base/share/share'
import ScrollBox from 'base/scrollBox/scrollBox'
import UploadFile from 'base/upload/uploadFile'
import {formatFileInfo, promiseUrlToQRCode} from 'common/js/tools'
import {contentMsg, spackageItemMsg, getSpackageList, delAndPutaway, recommend, deleteSpecialColumn, specilaSort, specialUpdate} from '@/api/spackageApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'spackageContentMgt',
    data() {
        return {
            total: 0,
            item: {
                subject: '',
                description: '',
                price: 0,
                feetypeName: '',
                coverPicture: {
                    furl: ''
                },
                counts: ''
            },
            tableData: [],
            param: {
                subject: '',
                assetinnerid: this.$route.query.innerid
            },
            page: {},
            sortShowId: null,
            sortNum: '',
            subInnerid: '',
            disabled: true
        }
    },
    mounted() {
        this.page = this.$refs.page.page
    },
    created() {
        this._getList({page: 1, pageSize: 10})
        if (this.$route.query.innerid) {
            this.getItemSpackageMsg(this.param.assetinnerid)
        }
    },
    methods: {
        download(imgsrc, name) { // 下载图片地址和图片名
            downloadImage(imgsrc, name)
        },
        // 复制成功
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        // 复制失败
        onError(e) {
            alert('失败')
        },
        // 排序
        sortShow(row) {
           this.sortShowId = row.innerid
        },
        confirmSort(row) {
            if (this.sortNum) {
                specilaSort({
                    data: {showorder: this.sortNum, innerid: row.innerid},
                    success: data => {
                        if (data.code === '000') {
                            this.$message({
                                type: 'success',
                                message: '排序成功'
                            })
                            this._getList(this.$refs.page.page)
                            this.sortNum = ''
                            this.sortShowId = ''
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        pCancel(ref) {
            this.$refs[ref].doClose()
        },
        handleShareClick() {
            this.$refs.spackageContentEdit.openDialog()
        },
        // 编辑目录
        handleCatalogEdit(row) {
            if (row.kmctype === 1) {
                this.$router.push({path: '/cms/article/articleEdit', query: {innerid: row.sourcekeyid}})
            } else if (row.kmctype === 2) {
                this.$router.push({path: '/cms/report/reportEdit', query: {id: row.sourcekeyid}})
            } else if (row.kmctype === 4) {
                this.$router.push({path: '/cms/videoMgt/videoEdit', query: {id: row.sourcekeyid}})
            } else if (row.kmctype === 5) {
                this.$router.push({path: '/cms/spackage/spackageEdit', query: {innerid: row.sourcekeyid}})
            }
        },
        // 获取列表数据
        _getList(page) {
            this.setLoading(true)
            contentMsg({
                data: Object.assign({}, page, this.param),
                success: data => {
                    this.setLoading(false)
                    for (let i = 1; i <= data.data.length; i++) {
                        data.data[i - 1].sort = i
                    }
                    data.data.list.forEach((obj, index) => {
                        obj.visible = false
                        obj.sortNum = index + 1
                        promiseUrlToQRCode(obj.shareurl, obj.coverurl).then(
                            function(data) {
                                obj.qrShare = data
                            },
                            function(reason, data) {
                                console.log('二维码生成失败：', reason)
                            }
                        )
                    })
                    this.tableData = data.data.list
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 分享
        shareSpackageContent(row) {
            // row.visible = true
        },
        // 新增商品
        shopAdd() {
            this.$refs.addShop.openDialog()
        },
        // 获取商品数据
        setShop() {
            this._getList(this.page)
            this.getItemSpackageMsg(this.param.assetinnerid)
        },
        // 获取单个专题信息
        getItemSpackageMsg(innerid) {
            spackageItemMsg({
                data: {innerid},
                success: data => {
                    // promiseUrlToQRCode(data.data.share, data.data.coverurl).then(
                    //     function(data) {
                    //         data.data.qrShare = data
                    //     },
                    //     function(reason, data) {
                    //         console.log('二维码生成失败：', reason)
                    //     }
                    // )
                    this.item = data.data
                    this.item.coverPicture = JSON.parse(this.item.coverPicture)
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        handleEdit(parameter) {
            this.$router.push({name: 'SpackageEdit', query: {innerid: parameter.assetinnerid}})
        },
        // 上架
        putAway(parameter) {
            this.$confirm('确定需要将该商品上架吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                delAndPutaway({
                    data: {innerid: parameter.assetinnerid, status: '30'},
                    success: data => {
                        if (data.code === '000') {
                            this.getItemSpackageMsg(this.$route.query.innerid)
                            this.$message({
                                type: 'success',
                                message: '上架成功'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 下架
        soldOut(parameter) {
            this.$confirm('确定需要将该商品下架吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                delAndPutaway({
                    data: {innerid: parameter.assetinnerid, status: '31'},
                    success: data => {
                        if (data.code === '000') {
                            this.getItemSpackageMsg(this.$route.query.innerid)
                            this.$message({
                                type: 'success',
                                message: '下架成功'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 删除
        handleDel(parameter) {
            this.$confirm('确定将该商品删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                delAndPutaway({
                    data: {innerid: parameter.assetinnerid, status: '100'},
                    success: data => {
                        if (data.code === '000') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                            this.$router.push('/cms/spackage/spackageList')
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 停止更新
        stopToUpdate(parameter) {
            this.$confirm('确定要将该商品停止更新吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                specialUpdate({
                    data: {innerid: this.$route.query.innerid, isupdate: '0'},
                    success: data => {
                        if (data.code === '000') {
                            this.getItemSpackageMsg(this.$route.query.innerid)
                            this.$message({
                                type: 'success',
                                message: '停止更新成功!'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
                
            }).catch(() => {})
        },
        // 开始更新
        beginToUpdate(parameter) {
            this.$confirm('确定将该商品开始更新吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                specialUpdate({
                    data: {innerid: this.$route.query.innerid, isupdate: '1'},
                    success: data => {
                        if (data.code === '000') {
                            this.getItemSpackageMsg(this.$route.query.innerid)
                            this.$message({
                                type: 'success',
                                message: '开始更新成功!'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 加入推荐
        handleRecommend(parameter) {
            this.$confirm('确定将该商品加入推荐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                recommend({
                    data: Object.assign({}, {innerid: parameter.assetinnerid, isinnerrecomm: '1'}),
                    success: data => {
                        if (data.code === '000') {
                            this.getItemSpackageMsg(this.$route.query.innerid)
                            this.$message({
                                type: 'success',
                                message: '推荐成功'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 取消推荐
        cancelRecommend(parameter) {
            this.$confirm('确定将该商品取消推荐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                recommend({
                    data: Object.assign({}, {innerid: parameter.assetinnerid, isinnerrecomm: '0'}),
                    success: data => {
                        if (data.code === '000') {
                            this.getItemSpackageMsg(this.$route.query.innerid)
                            this.$message({
                                type: 'success',
                                message: '取消推荐成功'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 搜索
        search() {
            this._getList(this.page)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {
        status(value) {
            switch (value) {
                case 10: 
                    return '待上架'
                break
                case 30: 
                    return '已上架'
                break
                case 31:
                    return '已下架'
            }
        }
    },
    watch: {
        'subInnerid': {
            handler(newV, oldV) {
                if (newV !== '') {
                    this.disabled = false
                }
            }
        },
        deep: true,
        immediate: true
    },
    computed: {
        ...mapGetters([
            'permission'
        ])
    },
    components: {
        // SpackageCatalogEdit,
        // SpackageVideoEidt,
        // SpackageContentEdit,
        Page,
        // SpackageLocalhostVideoEdit,
        // ScrollBox,
        // UploadFile
        AddShop,
        Share
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
@import "~common/scss/variable";
.spackageContentMgt {
    .content{
        background: $bgcolor-lightgrey;
        margin-bottom: 40px;
        img{
            min-width: 240px;
            height: 136px;
            width: 240px;
            margin: 20px 0 20px 20px;
        }
        @include flexBox(flex-start);
        .detailed{
            margin: 0 10px;
            flex-grow: 1;
            .title{
                @include flexBox(space-between);
                font-size: $font-16;
                .tr{
                    .el-popover{
                        .spackageList-pr-code-upload{
                            .img{
                                width: 156px;
                                height: 162px;
                            }
                        }
                    }
                }
            }
            .info{
                font-size: $font-14;
                margin: 10px 0;
                color: $tcolor-gray;
                width: 765px;
                height: 42px;
                line-height: 21px;
                overflow: hidden;
                .text {
                    float: right;
                    /* "margin-left"要等于".wrap::before"的宽度 */
                    margin-left: -10px;
                    width: 765px;
                    word-break: break-all;
                }
                &::before {
                    float: left;
                    content: '';
                    width: 10px;
                    height: 100%;
                }
                &::after {
                    float: right;
                    content: "...";
                    /* 行高与".wrap"设置的一致即可 */
                    height: 42px;
                    line-height: 21px;
                    /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                    width: 37px;
                    margin-left: -37px;
                    /* 移动省略号位置 */
                    position: relative;
                    left: 100.7%;
                    bottom: 21px;
                    /* "padding"左右总和的值要小于等于".wrap::before"的宽度，但不能为0 */
                    padding-right: 1px;
                    /*省略号左方的渐变色*/
                    background: #FAFAFA;
                    // background: linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -moz-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -o-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -ms-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), to(white), color-stop(20%, white));
                }
            }
            .statusBox{
                .status{
                    color: $tcolor-blue;
                }
            }
            .status,.price{
                margin: 10px 0;
                font-size: $font-12;
            }
            .price{
                margin-top: 15px;
            }
        }
    }
    .filters{
        .add{
            .el-button{
                width: 100px;
            }
        }
    }
    .source,.order{
        text-align: center;
    }
    .result-list{
        .productBox{
            .cell{
                padding: 0;
            }
        }
        .product{
            display: flex;
            .imgBox{
                width: 100px;
                height: 60px;
                img{
                    min-width: 100px;
                    max-width: 100px;
                    height: 60px;
                }
            }
            .textBox{
                margin-left: 5px;
                .feetype{
                    color: #F56C6C;
                }
                .title{
                    width: 340px;
                    height: 40px;
                    line-height: 20px;
                    overflow: hidden;
                    .text{
                        float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        margin-left: -10px;
                        width: 340px;
                        word-break: break-all;
                        // font-size: 0.48rem;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 10px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 40px;
                        line-height: 20px;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 37px;
                        margin-left: -37px;
                        /* 移动省略号位置 */
                        position: relative;
                        left: 103%;
                        bottom: 20px;
                        font-weight: 600;
                        padding-right: 1px;
                        background: #fff;
                        transition: all 0.5s;
                    }
                }
            }
        }
        .el-table__row:hover{
            .textBox{
                .title{
                    &::after{
                        background: #F5F7FA;
                    }
                }
            }
        }
        .status10{
            color: #409EFF;
        }
        .status30{
            color: #67C23A;
        }
        .status31{
            color: #909399;
        }
    }
    .sort-edit{
        @include flexBox(space-around);
        position: absolute;
        right: 10px;
        width: 334px;
        height: 54px;
        box-shadow:0px 2px 12px 0px rgba(0,0,0,0.06);
        border-radius: 4px;
        top: 0;
        background: #fff;
        margin-top: 20px;
        box-sizing: border-box;
        color: #909399;
        .el-input{
            width: 50px;
            margin:0 5px;
            input{
                padding: 5px 15px;
                height: 30px;
                line-height: 30px;
            }
        }
        .el-button{
            width: 60px;
            height: 30px;
            margin-left: 10px;
        }
    }
    .slide-sort-enter-active, .slide-sort-leave-active{
        transition: all 0.3s
    }
    .slide-sort-enter, .slide-sort-leave-to{
        transform: translate3d(100%, 0, 0)
    }
}

</style>
